import { Grow } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUserType } from "../utility/Redux/profile";
import { selectToken } from "../utility/Redux/security";
import { decodeToken } from "../utility/constant";
import { themesColor } from "../utility/functions/common";

const Reports = () => {
  const navigation = useNavigate();
  const token = useSelector(selectToken);
  const user_module = decodeToken(token)?.user_modules || "default";
  const user_modules = user_module.split(",");
  const list = [
    {
      name: "Sale Summary",
      path: "/sale_summary",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/sale_summary");
      },
    },

    {
      name: "Voucher Summary",
      path: "/voucher_summary",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/voucher_summary");
      },
    },

    {
      name: "Offer Report",
      path: "/offer_list",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/offer_list");
      },
    },

    {
      name: "Sale Tax Report",
      path: "/sale_tax_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/sale_tax_report");
      },
    },

    {
      name: "Customer Ledger",
      path: "/customer_ledger",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/customer_ledger");
      },
    },
    {
      name: "Customer Balance",
      path: "/customer_balance_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/customer_balance_report");
      },
    },
  ];
  const list2 = [
    {
      name: "Daily Stock Movement",
      path: "/Closing_Value_Report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/Closing_Value_Report");
      },
    },
    {
      name: "Purchase Summary",
      path: "/purchase_summary",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/purchase_summary");
      },
    },
    {
      name: "Debit Note Report",
      path: "/debit_note_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/debit_note_report");
      },
    },
    {
      name: "Credit Note Report",
      path: "/credit_note_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/credit_note_report");
      },
    },
    {
      name: "Party Ledger",
      path: "/party_ledger",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/party_ledger");
      },
    },

    {
      name: "Item Status",
      path: "/item_status",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/item_status");
      },
    },
    {
      name: "Stock Report",
      path: "/stock_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/stock_report");
      },
    },
    {
      name: "Party Wise Balance Report",
      path: "/party_bal_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/party_bal_report");
      },
    },
  ];

  const list3 = [
    {
      name: "FieldWay DFR",
      path: "/fieldway_dfr",
      userType: "ADMIN",
      onclick: () => {
        navigation("/fieldway_dfr");
      },
    },
    {
      name: "FieldWay Location",
      path: "/fieldway_location",
      userType: "ADMIN",
      onclick: () => {
        navigation("/fieldway_location");
      },
    },
  ];
  const list4 = [
    {
      name: "Issue Summary",
      path: "/issue_summary",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/issue_summary");
      },
    },
    {
      name: "Recieve Summary",
      path: "/recieve_summary",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/recieve_summary");
      },
    },
    {
      name: "Department Wise Issue Report",
      path: "/dep_wise_issue",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/dep_wise_issue");
      },
    },
    {
      name: "Department Wise Received Report",
      path: "/dep_wise_recieve",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/dep_wise_recieve");
      },
    },
  ];
  const list5 = [
    {
      name: "Pending Payments Of Deliverd",
      path: "/pending_payments_of_deliverd",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/pending_payments_of_deliverd");
      },
    },
  ];

  const list6 = [
    {
      name: "Order Report",
      path: "/order_report",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/order_report");
      },
    },
  ];
  const list7 = [
    {
      name: "Party Wise Item Sale",
      path: "/party_Items_Sale",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/party_Items_Sale");
      },
    },
    {
      name: "Item Expiry Report",
      path: "/item_expiry_reports",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/item_expiry_report");
      },
    },
    {
      name: "Item Wise Purchase Report",
      path: "/item_wise_purchase_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/item_wise_purchase_report");
      },
    },
    {
      name: "Item Purchase history",
      path: "/item_wise_purchase",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/item_wise_purchase");
      },
    },
    {
      name: "Item Wise Issue Report",
      path: "/item_wise_issue",
      userType: "STORE MANAGER",
      onclick: () => {
        navigation("/item_wise_issue");
      },
    },
    {
      name: "Item Wise Sale Report",
      path: "/item_wise_sale_report",
      userType: "MANAGER,USER,STORE",
      onclick: () => {
        navigation("/item_wise_sale_report");
      },
    },
  ];
  const userType = useSelector(selectUserType);

  const userWiseList = list.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });
  const userWiseList2 = list2.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });

  const userWiseList3 = list3.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });

  const userWiseList4 = list4.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });

  const userWiseList5 = list5.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });

  const userWiseList6 = list6.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });
  const userWiseList7 = list7.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      return o.userType.toLowerCase().includes(userType.toLowerCase());
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });
  return (
    <div className="h-full p-4 overflow-y-auto">
      {userWiseList[0] && userType !== "STORE" && (
        <div
          style={{
            border: "1px solid #f5874f", // bright orange border, no gray
            fontSize: "13px",
            fontWeight: "500",
            backgroundColor: "#0d0d0d", // deep dark black
          }}
          className="w-fit flex items-center gap-2 mb-2 text-white rounded-br-3xl"
        >
          <div className="bg-[#f5874f] px-2 py-1 ">
            <i className="bi bi-currency-dollar text-white text-base"></i>
          </div>
          <div className="py-1 pe-3">Sales Reports</div>
        </div>
      )}

      {userWiseList[0] && userType !== "STORE" && (
        <div className="grid pb-3 grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
          {userWiseList[0] &&
            userWiseList.map((e, i) => {
              return (
                <Grow
                  key={i}
                  in={true}
                  style={{ transformOrigin: "0 0 0" }}
                  {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                >
                  {buttonCard(i, e, userType)}
                </Grow>
              );
            })}
        </div>
      )}

      {userWiseList2[0] && (
        <div className="">
          <div
            style={{
              border: "1px solid #f5874f", // orange border, no gray
              fontSize: "13px",
              fontWeight: "500",
              backgroundColor: "#0d0d0d", // deep dark black
            }}
            className="w-fit flex items-center gap-2 mb-2 text-white rounded-br-3xl"
          >
            <div className="bg-[#f5874f] px-2 py-1 ">
              <i className="bi bi-cart-plus text-white text-base"></i>
            </div>
            <div className="py-1 pe-3">Purchase Reports</div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
            {userWiseList2[0] &&
              userWiseList2.map((e, i) => {
                return (
                  <Grow
                    key={i}
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                  >
                    {buttonCard(i, e, userType)}
                  </Grow>
                );
              })}
          </div>
        </div>
      )}
      {userWiseList4[0] && (
        <div className="mt-3">
          <div
            style={{
              border: "1px solid #f5874f",
              fontSize: "13px",
              fontWeight: "500",
              backgroundColor: "#0d0d0d",
            }}
            className="w-fit flex items-center gap-2 mb-2 text-white rounded-br-3xl"
          >
            <div className="bg-[#f5874f] px-2 py-1 ">
              <i className="bi bi-box-arrow-right text-white text-base"></i>
            </div>
            <div className="py-1 pe-3">Issue Reports</div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
            {userWiseList4[0] &&
              userWiseList4.map((e, i) => {
                return (
                  <Grow
                    key={i}
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                  >
                    {buttonCard(i, e, userType)}
                  </Grow>
                );
              })}
          </div>
        </div>
      )}

      {userWiseList3[0] && (
        <div className="">
          <div className="py-2 font-semibold">FieldWay Report :</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
            {userWiseList3[0] &&
              userWiseList3.map((e, i) => {
                return (
                  <Grow
                    key={i}
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                  >
                    {buttonCard(i, e, userType)}
                  </Grow>
                );
              })}
          </div>
        </div>
      )}

      {userWiseList5[0] && userType !== "STORE" && (
        <div className="mt-3">
          <div
            style={{
              border: "1px solid #f5874f", // matching border, fiery orange
              fontSize: "13px",
              fontWeight: "500",
              backgroundColor: "#0d0d0d", // deep dark black, no gray!
            }}
            className="w-fit flex items-center gap-2 mb-2 text-white rounded-br-3xl"
          >
            <div className="bg-[#f5874f] px-2 py-1 ">
              <i className="bi bi-truck text-white text-base"></i>
            </div>
            <div className="py-1 pe-3">Delivery Reports</div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
            {userWiseList5[0] &&
              userWiseList5.map((e, i) => {
                return (
                  <Grow
                    key={i}
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                  >
                    {buttonCard(i, e, userType)}
                  </Grow>
                );
              })}
          </div>
        </div>
      )}

      {userWiseList6[0] && (
        <div className="mt-3">
          <div
            style={{
              border: "1px solid #f5874f", // matching fiery orange border
              fontSize: "13px",
              fontWeight: "500",
              backgroundColor: "#0d0d0d", // deep black bg, no gray
            }}
            className="w-fit flex items-center gap-2 mb-2 text-white rounded-br-3xl"
          >
            <div className="bg-[#f5874f] px-2 py-1 ">
              <i className="bi bi-file-earmark-bar-graph text-white text-base"></i>
            </div>
            <div className="py-1 pe-3">Order Reports</div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
            {userWiseList6[0] &&
              userWiseList6.map((e, i) => {
                return (
                  <Grow
                    key={i}
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                  >
                    {buttonCard(i, e, userType)}
                  </Grow>
                );
              })}
          </div>
        </div>
      )}

      {userWiseList7[0] && (
        <div className="mt-3">
          <div
            style={{
              border: "1px solid #f5874f", // matching fiery orange border
              fontSize: "13px",
              fontWeight: "500",
              backgroundColor: "#0d0d0d", // deep black bg, no gray
            }}
            className="w-fit flex items-center gap-2 mb-2 text-white rounded-br-3xl"
          >
            <div className="bg-[#f5874f] px-2 py-2 ">
              <i className="bi bi-box-seam"></i>
            </div>
            <div className="py-2 pe-3"> Item Movement Reports</div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-3 d:grid-cols-5 ll:grid-cols-6 gap-3   ">
            {userWiseList7[0] &&
              userWiseList7.map((e, i) => {
                return (
                  <Grow
                    key={i}
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
                  >
                    {buttonCard(i, e, userType)}
                  </Grow>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Reports;
export function buttonCard(i, e, userType) {
  return (
    <button
      key={i}
      onClick={() => {
        e.onclick();
      }}
      variant={"contained"}
      style={{
        textTransform: "none",
        backgroundColor: "transparent",
        padding: "0px",
        borderRadius: "7px",
        overflow: "hidden",
        boxShadow: "3px 3px 8px #BDC2C6, -3px -3px 3px #ffffff",
      }}
    >
      <div
        style={{
          backgroundColor: themesColor().backgroundColor,
        }}
        className=" py-4 w-full text-black"
      >
        {e.name}
      </div>
    </button>
  );
}
